module.exports = __webpack_public_path__ + "@/assets/img/Servipag.dfec8cea.png";